import { apiRequest } from '../../apiCall'


export const postLogin = (params) => apiRequest('Auth.Login', params, '', true)



